import { useCallback, useState } from "react";

import axios from "utils/axios";
import { useQuery } from "@tanstack/react-query";

export const useGetClientStats = (clientid) => {
  return useQuery({
    queryKey: ["clientstats", clientid],
    queryFn: async () => {
      const response = await axios.get(`/clients/${clientid}/statistics`);
      return response.data;
    },
    enabled: !!clientid
  });
};
export const useGetClientById = (clientid) => {
  return useQuery({
    queryKey: ["clientbyid", clientid],
    queryFn: async () => {
      const response = await axios.get(`/clients/${clientid}`);
      return response.data;
    },
    enabled: !!clientid
  });
};

export const useGetSubClients = (pageSize, clientid) => {
  const [page, setPage] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [size, setSize] = useState(pageSize);

  const jump = useCallback((page) => {
    setPage(page);
  }, []);

  const search = useCallback((k) => {
    setKeyword(k);
  }, []);

  const itemPerPage = useCallback((sz) => {
    setSize(sz);
  }, []);

  return useQuery({
    queryKey: ["subclients", page, size, keyword, clientid],
    queryFn: async () => {
      const { data: response } = await axios.get(`/clients/${clientid}/subclients`, {
        params: {
          recursive: true,
          page,
          size,
          sort: "id,desc",
          search: keyword
        }
      });

      return {
        setPage,
        jump,
        search,
        itemPerPage,
        data: response.data,
        currentPage: page,
        totalElements: response.data.totalElements,
        totalPages: response.data.totalPages
      };
    },
    enabled: !!clientid
  });
};
